import { ILabelLocales } from "../personal-data/locales";

export const LabelLocales: ILabelLocales = {
    NoPaymentFound: 'No Payments Found.',
    LoadMore: 'Load more',
}